export class DisplayMethod {
  displayMethodId: string;
  displayMethodName: string;
}
